module.exports = __webpack_public_path__ + "static/media/Necrozma_gaussian2.ab70fd36.png";